export const getdgrgroupdet = (state = [], action) => {
  switch (action.type) {
    case "GET_DEGGROUP_DATA":
      return action.payload.data;
    default:
      return state;
  }
};
